/* eslint max-len: off */
import React from 'react';
import {Icon} from '../createSvg';
import {IconProps} from '../types';

export const Http = (props: IconProps) => (
  <Icon {...props}>
    <path d="M4.5 11H2.5V9H1V15H2.5V12.5H4.5V15H6V9H4.5V11ZM7 10.5H8.5V15H10V10.5H11.5V9H7V10.5ZM12.5 10.5H14V15H15.5V10.5H17V9H12.5V10.5ZM23 9H18V15H19.5V13H23V9ZM21.5 11.5H19.5V10.5H21.5V11.5Z" />
  </Icon>
);
